import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./BillingComponent.module.css";
import moment from "moment";
import { fetchDiagnosisList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";

import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
    }`;
}

export class Diagnosis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search_filter: "code",
      search_key: "",
      page: 1,
      sortName: "",
      sortOrder: "",
      sortBy: "",
      isDataFetched: false,
      diagnosisList: [],
      isLoading: false,
      selectedRow: {},
      infoRow: {},
      extended_diagnosis: "",
      isModalOpen: false,
      isInfoModelOpen: false
    };
    this.setLoader = this.setLoader.bind(this);
  }


  componentDidMount = async () => {

    const payload = this.getPayload();
    await this.props.fetchDiagnosisList(this.state.page, payload);
    if (this.props.diagnosisListData &&
      this.props.diagnosisListData.diagnosisList &&
      this.props.diagnosisListData.diagnosisList.icd10s &&
      this.props.diagnosisListData.diagnosisList.icd10s.pageResult &&
      this.props.diagnosisListData.diagnosisList.icd10s.pageResult.length > 0) {
      this.setState({
        diagnosisList: this.props.diagnosisListData.diagnosisList.icd10s.pageResult
      })
    }
    setTimeout(() => {
      this.setState({
        isDataFetched: true,
      });
    }, 1000);

  }

  getPayload = () => {
    return {
      search_filter: this.state.search_filter,
      search_key: this.state.search_key,
    };
  }

  callDiagnosisListAPI = async () => {
    this.setState({
      diagnosisList: []
    })
    const payload = this.getPayload();
    await this.props.fetchDiagnosisList(this.state.page, payload);
    if (!this.props.diagnosisListData.loading) {
      if (this.props.diagnosisListData &&
        this.props.diagnosisListData.diagnosisList &&
        this.props.diagnosisListData.diagnosisList.icd10s &&
        this.props.diagnosisListData.diagnosisList.icd10s.pageResult &&
        this.props.diagnosisListData.diagnosisList.icd10s.pageResult.length > 0) {
        this.setState({
          diagnosisList: this.props.diagnosisListData.diagnosisList.icd10s.pageResult
        })
      }
    }
    setTimeout(() => {
      this.setState({
        isDataFetched: true,
      });
    }, 500);
  }

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    }, () => {
      this.callDiagnosisListAPI();
    });

  };

  onPageChange = (page, sizePerPage) => {
    this.setState({
      page,
      isDataFetched: false
    }, () => {
      this.callDiagnosisListAPI();
    });
  };

  // toggle a modal
  toggle = (val) => {
    this.setState((prevState) => ({
      isModalOpen: !prevState.isModalOpen,
      extended_diagnosis: "",
    }));
  }

  openModal = (row) => {
    this.setState((prevState) => ({
      isInfoModelOpen: !prevState.isInfoModelOpen,
      infoRow: prevState.isInfoModelOpen === true ? {} : row,
    }));
  }

  handleSelectDiagnosisType = (event) => {
    let val = event.target.value;
    let name = event.target.name;

    this.setState({
      [name]: val
    })
  }

  handleSubmit = () => {
    this.setState({
      isModalOpen: false
    }, () => {
      this.handleAddDiagnosis(this.state.selectedRow)
    })
  }

  handleCheckDiagnosis = (row) => {
    this.setState({
      selectedRow: row
    }, () => {
      this.toggle();
    })
  }

  handleAddDiagnosis = (row) => {

   // console.log("diagnosis data", row)
    this.setState({
      isLoading: true
    })

    const payload = {
      doctor_type_code: "01",
      diagnosis_code_type: "01",
      diagnosis_code: row.code,
      diagnosis_description: row.description.substring(0, 70),
      extended_diagnosis: this.state.extended_diagnosis,
    }

    this.props.updateDiagnosisState(payload)
    this.setState({
      isLoading: false
    })
  }

  // Adding actions edit and delete icons
  actionsFormatter = (cell, row) => {
    return (
      <div>
        <span title="Add Diagnosis" onClick={() => this.handleCheckDiagnosis(row)}>
          <i className="fa fa-plus billing-plus-icon ml-2"></i>
        </span>
        {/* <Link title="View information" onClick={() => this.openModal(row)}>
          <i className="fa fa-info billing-plus-icon ml-3"></i>
        </Link> */}
      </div>
    );
  }

  formatDescription = (cell, row) => {
    if (!cell) {
      return "Not Available"
    }

    return (
      <div className="description" title={cell}>{cell}</div>
    )
  }

  handleInputChange = (event) => {
    let val = event.target.value;

    this.setState({
      search_key: val,
      page: 1,
      isDataFetched: false
    }, () => {
      this.callDiagnosisListAPI();
    })
  }

  handleInputSelectChange = (event) => {
    let filterval = event.target.value;

    this.setState({
      [event.target.name]: filterval,
      page: 1,
      isDataFetched: false
    }, () => {
      this.callDiagnosisListAPI();
    })
  }

  /**
   * This method will be called when there is not data or data is being fetched to show the loader.
   */
  setLoader = () => {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt='loader' className="loader-image" />
        </div>
      );
    }
  }

  /**
  * This method will be called to format the table data for valid data.
  * @param {string} data of the table column.
  * @returns {string} data or Not available string
  */
  checkValidData = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data;
    }
  }

  /**
  * This method will be called to format the table data for valid data.
  * @param {string} data of the table column.
  * @returns {string} data with first letter capital or Not available string
  */
  detailFormatter = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
    }
  }


  //   /**
  //    * This method will clear all the filters which are selected.
  //    */
  //   handleClearFilters = () => {
  //     this.setState({
  //       page: 1,
  //       sortName: "",
  //       sortOrder: "",
  //       sortBy: "",
  //       isDataFetched: false
  //     }, () => {
  //       this.callDiagnosisListAPI();
  //     })
  //   }


  /**
 * This will return filter form HTML for the render method.
 */
  getDiagnosisFilter = () => {

    return (
      <div className={`row form-group `}>
        <div class="col-md-12 d-flex flex-column flex-md-row">
          <input
            type="text"
            className={`form-control ${style.inputSearch}`}
            name="search_key"
            placeholder="Search here"
            onChange={this.handleInputChange}
            value={this.state.search_key}
          // onChange={this.onSearchChange}
          />
          <div class="d-flex mt-2 mt-md-0">
            <label class="form-control invoice-filter-label border-0">in</label>
            <select
              className="form-control"
              id="search_filter"
              name="search_filter"
              onChange={this.handleInputSelectChange}
              value={this.state.search_filter}
            >
              <option value="code">Code</option>
              <option value="description">Description</option>
            </select>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const diagnosisListData = this.props.diagnosisListData &&
      this.props.diagnosisListData.diagnosisList &&
      this.props.diagnosisListData.diagnosisList.icd10s;

    const primaryExist = this.props.diagnosis_codes.length > 0 &&
      this.props.diagnosis_codes.find((item) =>
        item.extended_diagnosis === "01" && item.delete !== true
      )

      //console.log("primaryExist", primaryExist)

    const data = this.state.infoRow;

    return (
      <div className="inventory-tab-wrapper flex-wrap">
        <div className="row">
          {/* <div className="col-md-12 d-flex justify-content-md-end">
              <a className="clearFilters"
                href="javascriptVoid:0"
                onClick={this.handleClearFilters}>
                Clear Filters
                </a>
            </div> */}
          <div className="col-md-12">
            {this.getDiagnosisFilter()}
          </div>
        </div>

        <div className="row">
          <div className={`col-md-12`}>
            <BootstrapTable
              remote={true}
              bordered={false}
              data={this.state.diagnosisList}
              version="4"
              search={false}
              pagination
              fetchInfo={{
                dataTotalSize: diagnosisListData && diagnosisListData.totalCount ? diagnosisListData.totalCount : 0,
              }}
              options={{
                searchvalue: "",
                sortName: this.state.sortName,
                sortOrder: this.state.sortOrder,
                onSortChange: this.onSortChange,
                onSearchChange: this.onSearchChange,
                sizePerPage: 10,
                page: this.state.page,
                onPageChange: this.onPageChange,
                noDataText: this.setLoader(),
              }}>
              <TableHeaderColumn
                dataField="code"
                isKey={true}
                dataFormat={this.checkValidData}
                width="10%"
              >
                Code
                </TableHeaderColumn>
              <TableHeaderColumn
                dataField="description"
                dataFormat={(cell, row) => this.formatDescription(cell, row)}
                width="80%"
              >
                Description
               </TableHeaderColumn>
              <TableHeaderColumn
                dataField="id"
                width="10%"
                dataFormat={this.actionsFormatter}
              >
                Add
               </TableHeaderColumn>
            </BootstrapTable>
            {this.state.isLoading ? (
              <div className={"loadingWrapper"}>
                <img
                  src={ttmLoader}
                  alt="loader"
                  className={style.loading}
                />
              </div>
            ) : (
                <div className={"textCenter"}>
                  {this.state.errorMessage && (
                    <p className=" error-message">
                      {this.state.errorMessage}
                    </p>
                  )}
                </div>
              )}

            <Modal
              isOpen={this.state.isModalOpen}
              toggle={this.toggle}
              className={style.deleteReason}
              centered
            >
              <ModalHeader
                toggle={this.toggle}
                className={style.deleteReasonHeader}
              >
                Diagnosis Type
            </ModalHeader>
              <ModalBody>
                <Formik
                  initialValues={this.state}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    extended_diagnosis: Yup.string().required("Diagnosis Type is required")
                  })}
                  onSubmit={this.handleSubmit}
                >
                  {({ errors, status, touched }) => (
                    <Form>
                      <div className={style.deleteReasonHeadingWrapper}>
                        <p>
                          Please select diagnosis type:{" "}
                        </p>
                      </div>
                      <div className={style.deleteReasonFormWrapper}>
                        <div className="form-group">
                          <Field
                            as="select"
                            name="extended_diagnosis"
                            className={
                              "form-control" +
                              (errors.extended_diagnosis && touched.extended_diagnosis
                                ? " is-invalid"
                                : "")
                            }
                            onChange={this.handleSelectDiagnosisType}
                            value={this.state.extended_diagnosis}

                          >
                            <option value="">Select Diagnosis Type</option>
                            {(typeof primaryExist === "undefined" || primaryExist === false ||
                              Number(primaryExist) === -1) && (<option value="01">Primary</option>)}
                            <option value="02">Secondary</option>
                            <option value="03">Co-Morbidity</option>
                            <option value="04">Complication</option>
                            <option value="05">Allergy</option>
                          </Field>
                          <ErrorMessage
                            name="extended_diagnosis"
                            component="div"
                            className="invalid-feedback"
                          />

                        </div>
                        <div className={`row ${style.deleteBtnWrapper}`}>
                          <div className="col-lg-12">
                            <div>
                              <button
                                type="submit"
                                disabled={this.state.successMessage}
                                className={`mr-4 ${style.deleteBtn}`}
                              >
                                Proceed
                        </button>
                              <button
                                type="button"
                                disabled={this.state.successMessage}
                                className={style.cancelBtn}
                                onClick={this.toggle}
                              >
                                Cancel
                        </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}

                </Formik>
              </ModalBody>
            </Modal>

            <Modal
              isOpen={this.state.isInfoModelOpen}
              toggle={this.openModal}
              className="viewProductDetailsModal"
              centered
            >
              <ModalHeader
                toggle={this.openModal}
                className={style.deleteReasonHeader}
              >
                Information
            </ModalHeader>
              <ModalBody>
                <div className={style.infoWrapper}>
                  <div class="row">

                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <label>ICD 10 Code</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkValidData(data.code)}
                        </div>
                      </div>
                      </div>
                      <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Description</label> :{" "}
                        </div>
                        <div className="col-md-6">
                          {data && this.checkValidData(data.description)}
                        </div>
                      </div>



                    </div>
                  </div>
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

// export default Users;
const mapStateToProps = (state) => {
  return {
    diagnosisListData: state.diagnosisList,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDiagnosisList: (page, payload) => dispatch(fetchDiagnosisList(page, payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Diagnosis);
